import { EventType } from '@/analytics/types';
import LandingPageBlurb from '@/app/components/LandingPage/LandingPageBlurb';

const ScienceAndResearchInnovation = (): JSX.Element => {
  const handleLinkClick = () => {
    const pathname = '/blog/category/meet-oura/oura-in-research/';

    void window.ouraAnalytics.track(EventType.CTAClicked, {
      cta: 'read_more',
      location: 'science and research',
      action: 'goes to blog',
      path: pathname,
    });

    window.open(pathname, '_blank');
  };

  return (
    <section className="py-14" data-cy="science-and-research-innovation">
      <LandingPageBlurb
        title={{
          key: 'science_and_research_innovation_title',
          indentation: 'pl-40 lg:pl-52 xl:pl-72',
          multiline: true,
          colEnd: {
            lg: 13,
          },
        }}
        description={{
          alignment: 'top',
          key: 'science_and_research_innovation_description',
        }}
        action={{
          arrow: true,
          className: 'px-0',
          title: 'science_and_research_innovation_action',
          onClick: handleLinkClick,
        }}
      />
    </section>
  );
};

export default ScienceAndResearchInnovation;
